export enum WorkReportSignDateEditType {
  NOT_CONTROLLED = 'NOT_CONTROLLED',
  UNCHANGEABLE = 'UNCHANGEABLE',
  MODIFIABLE = 'MODIFIABLE',
}

export const WorkReportSignDateEditTypeMap = {
  [WorkReportSignDateEditType.NOT_CONTROLLED]: '不受控',
  [WorkReportSignDateEditType.UNCHANGEABLE]: '不可改',
  [WorkReportSignDateEditType.MODIFIABLE]: '可修改',
};

export const WorkReportSignDateEditTypeList = [
  {
    label:
      WorkReportSignDateEditTypeMap[WorkReportSignDateEditType.NOT_CONTROLLED],
    value: WorkReportSignDateEditType.NOT_CONTROLLED,
  },
  {
    label:
      WorkReportSignDateEditTypeMap[WorkReportSignDateEditType.UNCHANGEABLE],
    value: WorkReportSignDateEditType.UNCHANGEABLE,
  },
  {
    label: WorkReportSignDateEditTypeMap[WorkReportSignDateEditType.MODIFIABLE],
    value: WorkReportSignDateEditType.MODIFIABLE,
  },
];

export const WorkReportSignDateEditTypeOptList = [
  {
    label:
      WorkReportSignDateEditTypeMap[WorkReportSignDateEditType.UNCHANGEABLE],
    value: WorkReportSignDateEditType.UNCHANGEABLE,
  },
  {
    label: WorkReportSignDateEditTypeMap[WorkReportSignDateEditType.MODIFIABLE],
    value: WorkReportSignDateEditType.MODIFIABLE,
  },
];
